import React from 'react'
import './FAQ.scss'
import h2ologo from './res/h2ologo.png'

function FAQ(){

    return (
        <div>
            <section class="dark">
                <div class="container py-4">
                    <h1 class="h1 text-center" id="pageHeaderTitle">FAQ Page</h1>
                    <article class="postcard dark blue">
                            <img class="postcard__img" src="https://wallpaperaccess.com/full/6961889.jpg" alt="Houston"/>
                        <div class="postcard__text">
                            <h1 class="postcard__title white">How can I contact H2O Motors?</h1>
                            <div class="postcard__subtitle small">
                                    <i class="fas fa-calendar-alt mr-2">Contact Info</i>
                            </div>
                            <div class="postcard__bar"></div>
                            <div class="postcard__preview-txt">If you're interested in a vehicle, find the particular Make/Model you're interested in. From our catalog, click on "View Details" on the specific vehicle, you can click on "Contact Us". This will allow you to send contact information so we can get in touch.</div>
                            <ul class="postcard__tagbox">
                                <li class="tag__item play blue">
                                    <a href="/vehicle-catalog"><i class="fas fa-play mr-2"></i>Our Catalog</a>
                                </li>
                            </ul>
                        </div>
                    </article>
                    <article class="postcard dark red">
                            <img class="postcard__img" src={h2ologo} alt="H2O Logo" />	
                        <div class="postcard__text">
                            <h1 class="postcard__title red">What if I have questions not regarding an inquiry?</h1>
                            <div class="postcard__subtitle small">
                                    <i class="fas fa-calendar-alt mr-2">Contact Info</i>
                            </div>
                            <div class="postcard__bar"></div>
                            <div class="postcard__preview-txt">For other questions please contact us at <a class="postcard__link" href="tel:111-222-1234">(111)-222-1234</a> or <a class="postcard__link" href="mailto: h2ohoustontx@gmail.com">h2ohoustontx@gmail.com</a> </div>
                        </div>
                    </article>
                    <article class="postcard dark green">
                            <img class="postcard__img" src="https://images.pexels.com/photos/104836/speed-car-vehicle-drive-104836.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Car Dash" />
                        <div class="postcard__text">
                            <h1 class="postcard__title green">What payment methods can I use?</h1>
                            <div class="postcard__subtitle small">
                                    <i class="fas fa-calendar-alt mr-2">Payment</i>
                            </div>
                            <div class="postcard__bar"></div>
                            <div class="postcard__preview-txt">We currently work with our customers with either cash or check. </div>
                        </div>
                    </article>
                    <article class="postcard dark yellow">
                            <img class="postcard__img" src="https://images.pexels.com/photos/70912/pexels-photo-70912.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Car Exterior" />
                        <div class="postcard__text">
                            <h1 class="postcard__title yellow">Can I see the vehicle?</h1>
                            <div class="postcard__subtitle small">
                                    <i class="fas fa-calendar-alt mr-2">Vehicle Information</i>
                            </div>
                            <div class="postcard__bar"></div>
                            <div class="postcard__preview-txt">Yes! We would be honored to show you our vehicles. 
                            We want you to feel assured that your potential vehicle is right for you.
                            Please browse our catalog for more vehicle information.</div>
                            <ul class="postcard__tagbox">
                                <li class="tag__item play blue">
                                    <a href="/vehicle-catalog"><i class="fas fa-play mr-2"></i>Our Catalog</a>
                                </li>
                            </ul>
                        </div>
                    </article>
                </div>
            </section>
      </div>
    );
}
export default FAQ;